import React, {useState, useRef, useEffect} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {Input, Select, Button, Modal, Col, Form, Row} from 'antd';
import {selectorItemsApi} from '../apiCalls/selectorItemsApi';
import {SelectorItem, SelectorItems} from '../apiCalls/selectorItems';
import {apiClient} from '../apiCalls/apiClient';

const SelectPackagingComponent: React.FC<{
  onChange?: (value: string) => void;
  title: string;
  defaultValue: {name: string; id: string} | string;
  endpoint?: string;
  mixType: string;
  pst: number;
  canDoPostRequest?: boolean;
}> = ({onChange, endpoint, title, defaultValue, mixType, pst, canDoPostRequest = true}) => {
  const [items, setItems] = useState<SelectorItems>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [initialValue, setInitialValue] = useState<string | undefined>(undefined);

  const [form] = Form.useForm();

  // useEffect(() => {
  //   fetchItems();
  // }, []);

  useEffect(() => {
    if (mixType === '') return;

    fetchItems();
  }, [mixType]);

  useEffect(() => {
    if (typeof defaultValue === 'string') {
      setInitialValue(defaultValue);
    } else if (defaultValue?.name) {
      setInitialValue(defaultValue.name);
    }
  }, [items]);

  const fetchItems = async () => {
    if (!endpoint) return;

    setIsLoading(true);

    try {
      const data = await selectorItemsApi.getItemList(endpoint);

      setItems(data);
    } catch (error) {
      console.error('Error fetching items:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        if (!endpoint) return;
        setConfirmLoading(true);

        await apiClient.post('/lists/packaging', {name: values.name, pst: pst, mixType: mixType});

        onChange && onChange(values.name);
        setConfirmLoading(false);
        setIsModalVisible(false);
        fetchItems();
      })
      .catch(() => {
        // error handled silently
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (isLoading) {
    return <div></div>;
  }

  return (
    <div>
      <Modal
        confirmLoading={confirmLoading}
        title={`Add new ${title}`}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item label="Name" name="name" rules={[{required: true, message: 'Please input name'}]}>
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {initialValue ? (
        <Select
          placeholder="Elegir opción"
          onChange={onChange}
          dropdownRender={(menu) => {
            if (!canDoPostRequest) {
              return <>{menu}</>;
            }

            return (
              <>
                {menu}
                <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                  Add item
                </Button>
              </>
            );
          }}
          defaultValue={initialValue}
          options={items.map((item: SelectorItem) => ({label: item.name, value: item.id ? item.id : item.name}))}
        />
      ) : (
        <Select
          placeholder="Elegir opción"
          onChange={onChange}
          dropdownRender={(menu) => {
            if (!canDoPostRequest) {
              return <>{menu}</>;
            }

            return (
              <>
                {menu}
                <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                  Add item
                </Button>
              </>
            );
          }}
          options={items.map((item: SelectorItem) => ({label: item.name, value: item.id ? item.id : item.name}))}
        />
      )}
    </div>
  );
};

export default SelectPackagingComponent;
